<template>
    <div class="core">
      <div class="layui-fluid">
          <pub-search :search-type="'add'" :tableObj="tableObj" :searchConfig="searchConfig" exportTemplate="客户表.xlsx">
            <template>
              <button class="layui-btn" title="新增客户" @click="add()">
                <i class="layui-icon">&#xe624;</i>
                新增客户
              </button>
<!--              <button class="layui-btn" title="导入" @click="importExcel()" v-if="true">-->
<!--                <span style="display:none" id="importWarpper">-->
<!--                  <form enctype="multipart/form-data" style="margin-top: 20px;margin-bottom:10px;">-->
<!--                      <div style="margin-left: 8.33333333%;">-->
<!--                          <input type="file" id="file" accept=".xls,.xlsx"/>-->
<!--                          <font color="red" style="margin-top:10px;display: block;">-->
<!--                            提示：仅允许导入“xls”或“xlsx”格式文件！-->
<!--                          </font>-->
<!--                      </div>-->
<!--                  </form>-->
<!--                </span>-->
<!--                <i class="layui-icon">&#xe624;</i>-->
<!--                导入-->
<!--              </button>-->
            </template>
          </pub-search>
          <layui-table
            ref="clientgs"
            table-name="YW_CUSTOMER_CLIENT"
            :page-size="20"
            :page-range="6"
            :page-options="[10, 20, 50, 100]"
            :skin="'line'"
            :slave-tables="['YW_CUSTOMER_BRAND']"
            :sort="['CREATE_TIME:DESC']"
            @table-event-edit="edit($event)"
            @table-event-del="$refs.clientgs.delRows($event.data)"
            @table-event-check="check($event)"
            :beforeRender="handleBeforeRnder"
          >
            <div>
                <div checkbox="true" align="center" fixed="left" width="60"></div>
                <!-- <div title="序号" width="60"  fixed="left" field="_NUMBER" align="center"></div> -->
                  <layui-tableconfig :config = "gsTableList"></layui-tableconfig>
                <div align="center" fixed="right" title="操作" width="130">
                  <script type="text/html" v-pre>
                    <a class=" layui-btn-xs" lay-event="check" style="cursor:pointer">查看</a>
                    <a class=" layui-btn-xs" lay-event="edit"  style="cursor:pointer">编辑</a>
                    <a class="layui-btn-xs layui-btn-xs-danger" lay-event="del"  style="cursor:pointer">删除</a>
                  </script>
                </div>
            </div>
          </layui-table>
      </div>
    </div>
</template>
<script>
import "../../../utils/map/css/core.css"

export default {
  name: 'client',
  data () {
    return {
        gsTableList:[
          // { field: 'MANAGER_ID_DESC', title: '项目经理', width: 120 },
          { field: 'CLIENT_BH', title: '客户编码', sort: true, width: 150 },
          { field: 'CLIENT_NAME', title: '客户名称' ,  width: 300},
          { field: 'PERSON_NAME', title: '联系人姓名' ,  width: 150},
          { field: 'PERSON_PHONE', title: '联系人电话' ,  width: 150},
          { field: 'PROVINCE_DESC', title: '省' ,  width: 110},
          { field: 'CITY_DESC', title: '市' ,  width: 110},
          { field: 'DISTRICT_DESC', title: '县' ,  width: 110},
          { field: 'ADDRESS', title: '地址' ,  width: 300},
          { field: 'INDUSTRY_TYPE_DESC', title: '行业类型', width: 110 },
          { field: 'CREATE_TIME', title: '创建时间', width: 170 },
        ],
        gsFormShow: false,
        gsFormType: null,
        gsFormData: null,
        tableObj: {
            checkedRows: 0,
            queryObject: {}
        },
        searchConfig: {
          basic: [
            { TYPE:'input',WIDTH: 260, FIELD: 'CLIENT_BH:2,CLIENT_NAME:2,PERSON_NAME:2,PERSON_PHONE:2,ADDRESS:2,', PLACEHOLDER: '请输入查询条件'},
          ],
          advanced: [
            { TYPE:'input', NAME: '客户编码 :', FIELD:'CLIENT_BH:2', PLACEHOLDER: '请输入查询条件'},
            { TYPE:'input', NAME: '客户名称 :', FIELD:'CLIENT_NAME:2', PLACEHOLDER: '请输入查询条件'},
            { TYPE:'input', NAME: '联系人姓名 :', FIELD:'PERSON_NAME:2', PLACEHOLDER: '请输入查询条件'},
            { TYPE:'input', NAME: '联系人电话 :', FIELD:'PERSON_PHONE:2', PLACEHOLDER: '请输入查询条件'},
            { TYPE:'input', NAME: '地址 :', FIELD:'ADDRESS:2', PLACEHOLDER: '请输入查询条件'},
            { TYPE: 'date', NAME: '创建时间 :', FIELD: 'CREATE_TIME:2' }
          ],
          showBatch: true
        },
    }
  },
  mounted(){
    this.tableObj = this.$refs.clientgs;
  },
  methods: {
    /**
     * 新增客户
     */
    add () {
      this.baseComponent.smartLoadComponent('clientForm', { tableObj: this.tableObj, formType: 'add', title: '新增客户'})
    },
    check($event){
      this.baseComponent.smartLoadComponent('clientBrowserForm', {editRow: $event.data, tableObj: this.tableObj, formType: 'browser', title: '查看客户', isBrowserStatus: true})
    },
    /**
     * 编辑
     */
    edit ($event){
       this.baseComponent.smartLoadComponent('clientForm', {editRow: $event.data, tableObj: this.tableObj, formType: 'edit', title: '编辑客户'})
    },
    handleBeforeRnder(data){
      if(data && data.length > 0) {
        data.forEach((e) => {
          e.SSD = (e.PROVINCE ? e.PROVINCE : '') + "," + (e.CITY ? e.CITY: '') + "," + (e.DISTRICT ? e.DISTRICT : '');
          //e.SSD_DESC = (e.PROVINCE ? e.PROVINCE_DESC : '') + "-" + (e.CITY ? e.CITY_DESC: '') + "-" + (e.DISTRICT ? e.DISTRICT_DESC : '') + "-" + e.ADDRESS
        })
      }
    },
    importExcel(){
        var that = this;
        this.layui.layer.open({
            type: 1,
            area: ['400px', '230px'],
            fix: false,
            //不固定
            maxmin: true,
            shade: 0.3,
            title: '上传数据',
            content: $('#importWarpper').html(),
            btn: ['<i class="fa fa-check"></i> 导入', '<i class="fa fa-remove"></i> 取消'],
            // 弹层外区域关闭
            shadeClose: true,
            btn1: function(index, layero){
                var file = layero.find('#file').val();
                if (file == '' || (!file.endsWith('.xls') && !file.endsWith('.xlsx'))){
                    that.layer.openAlert("请选择后缀为 “xls”或“xlsx”的文件。");
                    return false;
                }
                var index = layer.load(2, {shade: false});
                var formData = new FormData();
                formData.append("file", layero.find('#file')[0].files[0]);
                $.ajax({
                    url: process.env.API_HOST + '/historyData/import/client?token=' + that.security.getToken(),
                    data: formData,
                    cache: false,
                    contentType: false,
                    processData: false,
                    type: 'POST',
                    success: function (result) {
                        layer.closeAll();
                        if(result.errorMsg){
                            that.layer.openAlert(result.errorMsg);
                            return;
                        }
                        result = result.result;
                        layer.close(index);
                        if(result != ""){
                            that.$nextTick(()=> {
                                that.tableObj.load();
                            });
                        }
                    },
                    error: function(err){
                        layer.close(index);
                    }
                });
            }
        });
    },
  }
}
</script>



// WEBPACK FOOTER //
// src/components/person/clientManage/index.vue